// @ts-nocheck
import React from "react";
import useFetch from "../../../ApiClient/GetApi";
import { BASE_URL } from "../../../Utils/urls";
import Header from "../layout/Header";
import { useNavigate } from "react-router-dom";
export default function PaymentAndInvoice() {
  const navigate = useNavigate();
  const { data } = useFetch("users/home/user_all_invoices");

  const payment_details = (id) => {
    localStorage.setItem("orderId", id);
    navigate("/payment_details");
  };

  return (
    <>
      <section className="font-soehne">
        <Header />
        <div className="w-3/5 mx-auto py-10">
          <h1 className="text-center text-3xl font-semibold my-8">
            All Invoices
          </h1>
          <div className="bg-gray-300 py-2 my-1  rounded flex justify-between px-10">
            <p>S.No</p>
            <p>Booking ID</p>
            <p>Payment Status</p>
            <p>Action</p>
          </div>
          {data?.data?.map((invoice, index) => (
            <div className="bg-gray-300 py-2 my-1  rounded flex justify-between px-10 text-center">
              <p>{index + 1}</p>
              <p className="text-center">{invoice.BookingId}</p>
              <p className="text-center">
                {invoice.Booking?.paymentStatus === false ? (
                  <button
                    onClick={() => payment_details(invoice.BookingId)}
                    className="py-1 px-4
                         bg-themeBlue rounded text-white"
                  >
                    Make Payment
                  </button>
                ) : (
                  <button className="py-1 px-4 bg-themeGreen rounded text-green-900">
                    Payment Paid
                  </button>
                )}
              </p>
              <a
                href={BASE_URL + invoice.invoice}
                className="py-1 px-4 bg-themeYellow rounded text-white"
              >
                Download
              </a>
            </div>
          ))}
        </div>
      </section>
    </>
  );
}
